import { Enviroment } from "../../enviroments";
import { Api } from "../api/axios-config"
import { IDetalheUsuarioCadastro, UsuarioService, IRespostaCreate } from "../api/usuario/UsuarioService";
import CookieService from "./CookieService";

export interface autenticacao {
    autenticado: boolean
}

export interface Ilogin {
    chaveSessao: string;
    codUsuario: number;
    login: string;
    nome: string;
    sobrenome: string;
    email: string;
    termoUsu: boolean;
    lembrarme: boolean;
    codTema: number;
    dtExpiracao: Date;
    administrador: boolean;
    imagem_Perfil: string;
    pagamentoConcluido: boolean;
    codigo_Liga_Favorito?: number;
    dados_Incompletos: boolean;

}

// interface IDadosUsuario {

//     codigo: number;
//     nome: string;
//     email: string;
//     lembrarme: boolean;
//     login: string;
//     token: string;
//     autenticado: boolean;

// }

export interface IDadosLogin {
    usuario: string;
    senha: string;
    lembrarme: boolean;
    email: string;
    ip: string;

}

export interface IDadosRetorno {
    dado: Ilogin;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: any;
}

const authenticated = async (): Promise<Boolean> => {
    const token = CookieService.get("access_token");// localStorage.getItem("@Auth:token");                    
    const { data } = await Api.get<RespostaCreate>(`/Autenticacao/sessao/${token}`);    
    return data.dado;
}

const login = async (dadosAcesso: IDadosLogin): Promise<IDadosRetorno> => {

    const token = Enviroment.CHAVE_HOMOLOGACAO;
    const { data } = await Api.post<IDadosRetorno>(`/Autenticacao/login/`, dadosAcesso, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    
    return data;

}


const cadastrar = async (dadosCadastro: IDetalheUsuarioCadastro) : Promise<IRespostaCreate> => {
    return UsuarioService.createCadastro(dadosCadastro);
}

export const AuthService = {
    authenticated,
    login,
    cadastrar
   
}